import React from "react";
import { Button } from "@mui/material";
import { OtpInput } from "@/pages/OtpInput";
import { FormikProps } from "formik";
import { UpdateValues } from "../EditMyAccount";
import { useTranslation } from "react-i18next";

interface formikValues {
  otp: string;
}
interface OTPInputProps {
  formik: FormikProps<formikValues>;
  loading: boolean;
}

const OTPInput: React.FC<OTPInputProps> = ({ formik, loading }) => {
  const { t } = useTranslation("auth");
  return (
    <form onSubmit={formik.handleSubmit} className="tw-mb-6">
      <div className="tw-mb-6">
        <OtpInput
          numInputs={6}
          value={formik.values.otp}
          onChange={(value) => formik.setFieldValue("otp", value)}
          hasError={formik.touched.otp && Boolean(formik.errors.otp)}
          isDisabled={loading}
          autoFocus
          placeholder={t("phoneVerification.form.otp.placeholder")}
          className="tw-grid tw-grid-cols-6 tw-gap-2"
        />
        {formik.touched.otp && formik.errors.otp && (
          <div className="tw-text-red-500 tw-text-sm tw-mt-1">
            {formik.errors.otp}
          </div>
        )}
      </div>

      {/* Verify Button */}
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={loading}
        className="primary-custom-button tw-py-2"
      >
        {loading
          ? t("phoneVerification.form.button.loading")
          : t("phoneVerification.form.button.verify")}
      </Button>
    </form>
  );
};

export default OTPInput;
